import React, {useMemo} from 'react';
import {Box, Typography} from '@mui/material';
import {ArrowBackIos, ArrowForwardIos} from '@mui/icons-material';
import AurButton from '../../../common/aur-button/AurButton';
import {t} from 'i18next';

const FLAG_ONE = 1;

interface PaginationProps {
  currentIndex: number;
  maxIndex: number;
  disabled: boolean;
  onPrevious: () => void;
  onNext: () => void;
  previousButtonAriaLabel?: string,
  nextButtonAriaLabel?: string
}

const ModalPagination: React.FC<PaginationProps> = ({
  currentIndex,
  maxIndex,
  disabled,
  onPrevious,
  onNext,
  previousButtonAriaLabel,
  nextButtonAriaLabel
}) => {
  const isFirstActive = useMemo(() => {
    return currentIndex === 0;
  }, [currentIndex]);

  const isLastActive = useMemo(() => {
    return currentIndex === maxIndex - FLAG_ONE;
  }, [currentIndex, maxIndex]);

  return (
    <Box
      component="nav"
      aria-label={t('common.pagination.title')}
      className={'custom-modal-pagination-container'}
    >
      <AurButton
        type={'exit'}
        size="Medium"
        onClick={onPrevious}
        disabled={isFirstActive || disabled}
        dataTestId="previous-test"
        classNames="pagination-button"
        ariaLabel={previousButtonAriaLabel}
      >
        <ArrowBackIos fontSize="small" className="arrow-size" />
      </AurButton>

      <Box display={'flex'} gap={'8px'}>
        <Typography className="typo-text body2_size selected-text">
          {currentIndex + FLAG_ONE}
        </Typography>
        <Typography className="typo-text body2_size last-text">
          {t('common.of')} {maxIndex}
        </Typography>
      </Box>

      <AurButton
        type={'exit'}
        size="Medium"
        onClick={onNext}
        disabled={isLastActive || disabled}
        dataTestId="next-test"
        classNames="pagination-button"
        ariaLabel={nextButtonAriaLabel}
      >
        <ArrowForwardIos fontSize="small" className="arrow-size" />
      </AurButton>
    </Box>
  );
};

export {ModalPagination};
